import { isEmptyString } from '@/utils/string';
import { useLayoutEffect, useState } from 'react';

/**
 * Animates typing of text, simulating a typewriter effect when
 * the text changes.
 */

type TypeWriterTextProps = { text: string; speed?: number };

export function TypeWriterText({ text, speed = 50 }: TypeWriterTextProps) {
  const [displayText, setDisplayText] = useState('');

  useLayoutEffect(() => {
    if (text === displayText) {
      return;
    }

    if (isEmptyString(displayText)) {
      setDisplayText(text);
      return;
    }

    setDisplayText('');

    let currentIndex = 0;

    const typeInterval = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayText(text.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typeInterval);
      }
    }, speed);

    return () => clearInterval(typeInterval);
  }, [text, speed]);

  return <>{displayText}</>;
}
